import { Language as LanguageIcon } from '@mui/icons-material';
import { IconButton, Paper, Popover, Tooltip } from '@mui/material';
import { StyleSheet, css } from 'aphrodite';
import React, { useState } from 'react';
import { theme } from '../styling';

const styles = StyleSheet.create({
  filterWrapper: {
    padding: '16px',
    alignItems: 'center',
  },
  greenIcon: {
    color: theme.themeGreen,
  },
});

type Props = {
  children: React.ReactNode;
  empty: boolean;
};

const BaseLanguageFilterPopover: React.FC<Props> = (props) => {
  // hooks
  const [filterProps, setFilterProps] = useState({ buttonRef: null, open: false });

  // functions
  const openFilter = (e: any): void => {
    setFilterProps({ ...filterProps, open: true, buttonRef: e.currentTarget });
  };

  const closeFilter = (): void => {
    setFilterProps({ ...filterProps, open: false, buttonRef: null });
  };

  // render
  return (
    <div style={{ display: 'flex', marginRight: '30px' }}>
      <Tooltip title="Språk kandidaten talar" disableInteractive>
        <IconButton aria-label="Language filter" size="large" onClick={openFilter}>
          {props.empty ? <LanguageIcon /> : <LanguageIcon className={css(styles.greenIcon)} />}
        </IconButton>
      </Tooltip>

      <Popover
        open={filterProps.open}
        anchorEl={filterProps.buttonRef}
        onClose={closeFilter}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Paper className={css(styles.filterWrapper)}>{props.children}</Paper>
      </Popover>
    </div>
  );
};

export default BaseLanguageFilterPopover;
